import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Navigate, Link } from 'react-router-dom';

const SHOP_API_BASE_URL = process.env.REACT_APP_SHOP_API_BASE_URL || 'https://shop.dev.carouselshopai.com';
const PENDING_INVITATION_TOKEN_KEY = 'pendingInvitationToken';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [requireInviteCode, setRequireInviteCode] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${SHOP_API_BASE_URL}/api/v1/config`);
        if (response.ok) {
          const config = await response.json();
          setRequireInviteCode(config.requireInviteCode);
        }
      } catch (err) {
        // Default to invite code text if config fetch fails
      }
    };
    fetchConfig();
  }, []);

  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  // Already authenticated — redirect to dashboard
  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);

      // Check for pending invitation token
      const pendingToken = sessionStorage.getItem(PENDING_INVITATION_TOKEN_KEY);
      if (pendingToken) {
        sessionStorage.removeItem(PENDING_INVITATION_TOKEN_KEY);
        navigate(`/join/${pendingToken}`);
      } else {
        navigate('/');
      }
    } catch (error) {
      setError('Failed to log in. Please check your credentials.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form">
          <h2>Reseller Login</h2>
          <p className="login-subtitle">Access your Carousel Shop dashboard</p>
          
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            
            <button type="submit" disabled={loading} className="login-btn">
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="login-footer">
            <p><Link to="/forgot-password">Forgot Password?</Link></p>
            <p>Don't have an account? <Link to="/signup">{requireInviteCode ? 'Sign up with an invite code' : 'Sign up'}</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;